import { db, auth } from "./firebase";
import { collection, addDoc, deleteDoc, getDocs, getDoc, doc, query, where, serverTimestamp } from "firebase/firestore";

const MOVIE_REQUESTS_COLLECTION = "movieRequests";

/**
 * Request a movie to be added to Jellyfin
 */
export const requestMovie = async (imdbId, movieData) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("Debes iniciar sesión para solicitar películas");
    }

    // Check if already requested
    const existing = await getMovieRequest(imdbId);
    if (existing) {
      throw new Error("Esta película ya ha sido solicitada");
    }

    const requestData = {
      imdbId,
      title: movieData.title || movieData.Title || "Unknown",
      poster: movieData.poster_path ? `https://image.tmdb.org/t/p/w500${movieData.poster_path}` : movieData.Poster || null,
      year: movieData.release_date?.substring(0, 4) || movieData.Year || null,
      requestedBy: user.uid,
      requestedByName: user.displayName || user.email,
      requestedAt: serverTimestamp(),
      status: "pending",
    };

    const docRef = await addDoc(collection(db, MOVIE_REQUESTS_COLLECTION), requestData);
    console.log("Movie request created:", docRef.id);

    return { id: docRef.id, ...requestData };
  } catch (error) {
    console.error("Error requesting movie:", error);
    throw error;
  }
};

/**
 * Get a movie request by IMDB ID
 */
export const getMovieRequest = async (imdbId) => {
  try {
    const q = query(collection(db, MOVIE_REQUESTS_COLLECTION), where("imdbId", "==", imdbId));

    const snapshot = await getDocs(q);
    if (snapshot.empty) return null;

    const doc = snapshot.docs[0];
    return { id: doc.id, ...doc.data() };
  } catch (error) {
    console.error("Error getting movie request:", error);
    return null;
  }
};

/**
 * Get all movie requests
 */
export const getAllMovieRequests = async () => {
  try {
    const snapshot = await getDocs(collection(db, MOVIE_REQUESTS_COLLECTION));
    return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  } catch (error) {
    console.error("Error getting all movie requests:", error);
    return [];
  }
};

/**
 * Delete a movie request (when movie is added to Jellyfin)
 */
export const deleteMovieRequest = async (requestId) => {
  try {
    await deleteDoc(doc(db, MOVIE_REQUESTS_COLLECTION, requestId));
    console.log("Movie request deleted:", requestId);
    return true;
  } catch (error) {
    console.error("Error deleting movie request:", error);
    return false;
  }
};

/**
 * Check if a movie has already been requested by current user
 */
export const hasUserRequestedMovie = async (imdbId) => {
  const request = await getMovieRequest(imdbId);
  if (!request) return false;

  const user = auth.currentUser;
  return request.requestedBy === user?.uid;
};
